// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {noop} from 'lodash';

// Components
import Icon from './icon';

// Styles
import './button.scss';

export default class Button extends Component {
    getClass() {
        const {children, className, icon, small, type} = this.props;

        return classnames(
            {
                button: true,
                button_link: type === 'link',
                button_small: small,
                'button_with-icon': icon,
                'button_icon-only': icon && !children,
            },
            className
        );
    }

    getIconClass() {
        const {iconClassName} = this.props;

        return classnames(
            {
                'button--icon': true,
            },
            iconClassName
        );
    }

    getProps() {
        const {disabled, style, title, type, value} = this.props;

        return {
            className: this.getClass(),
            disabled,
            onClick: this.handleClick,
            style,
            title,
            type,
            value,
        };
    }

    handleClick = (event) => {
        const {onClick = noop} = this.props;

        onClick(event);
    };

    renderIcon() {
        const {icon} = this.props;
        let content = null;

        if (icon) {
            content = <Icon className={this.getIconClass()} fontType="fa" iconName={icon} />;
        }

        return content;
    }

    render() {
        const {children, value} = this.props;

        return (
            <button {...this.getProps()}>
                {children || value}
                {this.renderIcon()}
            </button>
        );
    }
}

Button.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    onClick: PropTypes.func,
    small: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
